import { useEffect } from 'react';
import type { DealerSageMappings } from '../types/dealerSageMappings.types';

interface Options {
    mappings: DealerSageMappings | undefined;
    editingKey: string | null;
    isSaving: boolean;
    cancelEdit: () => void;
}

export function useCancelOrphanedSageEdit({ mappings, editingKey, isSaving, cancelEdit }: Options): void {
    useEffect(() => {
        if (!mappings || editingKey === null || isSaving) return;
        if (!mappings.products.some((product) => product.productId === editingKey)) cancelEdit();
    }, [mappings, editingKey, isSaving, cancelEdit]);
}
